// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditProfilePopup__form-container-ae4baf {
  max-height: none;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/EditProfilePopup/EditProfilePopup.styles.m.css"],"names":[],"mappings":"AAAA;EACC,gBAAA;AACD","sourcesContent":[".form-container {\n\tmax-height: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form-container": `EditProfilePopup__form-container-ae4baf`,
	"formContainer": `EditProfilePopup__form-container-ae4baf`
};
module.exports = ___CSS_LOADER_EXPORT___;
